import { DataDispatchReport } from '../../../shared/modules/data-dispatch/enums/data-dispatch-report.enum';
import { TenantSettingsDto } from '../../settings';

export const getReportIdsMap = (
	settings: TenantSettingsDto,
): Record<DataDispatchReport, number> => {
	return {
		[DataDispatchReport.RENTAL_AGREEMENT_EMAIL_CUSTOMER_CONFIRMATION]:
			settings.reports?.rentalAgreements?.email?.customer?.confirmation
				?.reportId ?? 0,
		[DataDispatchReport.RENTAL_AGREEMENT_PRINT_AGREEMENT]:
			settings.reports?.rentalAgreements?.print?.agreement?.reportId ?? 0,
		[DataDispatchReport.RENTAL_RESERVATION_EMAIL_CUSTOMER_ACCEPTED_REQUEST_CONFIRMATION]:
			settings.reports?.rentalReservations?.email?.customer
				.acceptedRequestConfirmation.reportId ?? 0,
		[DataDispatchReport.RENTAL_RESERVATION_EMAIL_CUSTOMER_REJECTED_REQUEST_CONFIRMATION]:
			settings.reports?.rentalReservations?.email?.customer
				.rejectedRequestConfirmation.reportId ?? 0,
		[DataDispatchReport.RENTAL_RESERVATION_EMAIL_CUSTOMER_REQUEST_CONFIRMATION]:
			settings.reports?.rentalReservations?.email?.customer?.requestConfirmation
				.reportId ?? 0,
		[DataDispatchReport.PAYMENTS_EMAIL_PAYMENT_REQUEST]:
			settings.reports?.payments?.email?.paymentRequest?.reportId ?? 0,
	};
};
